import { useEffect, useState } from "react";
import type { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { getCoachDetails } from "../api/Patient";

interface AppShellProps extends PropsWithChildren {
  title?: string;
  subtitle?: string;
}

interface Coach {
  Id: string;
  FirstName: string;
  LastName: string;
}

function AppShell({ children }: AppShellProps) {
  const navigate = useNavigate();

  const [coach, setCoach] = useState<Coach | null>(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    getCoachDetails()
      .then((res) => {
        sessionStorage.setItem("coach", JSON.stringify(res));
        setCoach(res);
        console.log(coach)
      })
      .catch((error) => {
        console.error("Failed to load coach details:", error);
      });
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/signin");
  };

  const initials = coach
    ? `${coach.FirstName?.charAt(0) ?? ""}${coach.LastName?.charAt(0) ?? ""}`.toUpperCase()
    : "";

  console.log(coach)

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="header-logo">
           <img src="/assets/Logos/AppIcon.png" alt="logo" width="120" />
        </div>

        <div className="header-user">
          <div className="header-avatar-fallback">
            {initials}
          </div>

          <span className="header-user-name">
            {coach
              ? `${coach.FirstName} ${coach.LastName}`
              : "Loading..."}
          </span>

          <span
            className="header-chevron"
            onClick={() => setShowDropdown((prev) => !prev)}
          >
            ▼
          </span>

          {showDropdown && (
            <div className="user-dropdown">
              <button
                type="button"
                className="dropdown-item"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="app-main">
        {children}
      </main>
    </div>
  );
}

export default AppShell;